import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import {
  MmuPlanPermissionBooleanKey,
  MmuPlanPermissionKey,
  MmuPlanPermissionNumericKey,
  MmuPlanPermissionService
} from '../plan-permission-service/mmu-plan-permission.service';


@Directive({
  selector: '[mmuPlanPermission]'
})
export class MmuPlanPermissionDirective implements OnInit {
  @Input()
  mmuPlanPermission: MmuPlanPermissionKey | string = '';

  @Input()
  set mmuPlanPermissionCurrent(value: number) {
    this._permissionCurrentValue = value;
  }

  private _isRendered = false;
  private _permissionCurrentValue?: number;

  constructor(
    private planPermissionService: MmuPlanPermissionService,
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {
  }

  ngOnInit(): void {
    if (this.checkPermission()) {
      this.show();
    } else {
      this.hide();
    }
  }

  checkPermission(): boolean {
    if (this.mmuPlanPermission && this._permissionCurrentValue) {
      return this.planPermissionService.getPermit(this.mmuPlanPermission as MmuPlanPermissionNumericKey, this._permissionCurrentValue);
    } else if (this.mmuPlanPermission) {
      return this.planPermissionService.getPermit(this.mmuPlanPermission as MmuPlanPermissionBooleanKey);
    } else {
      return false;
    }
  }

  private show(): void {
    if (!this._isRendered) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this._isRendered = true;
    }
  }

  private hide(): void {
    this.viewContainerRef.clear();
    this._isRendered = false;
  }
}
